import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { BoobleModalService } from 'booble-modal';
import { AuthenticationService } from 'src/app/shared/services';

@Component({
  selector: 'app-generate-invoice-success-modal',
  templateUrl: './generate-invoice-success-modal.component.html',
  styleUrls: ['./generate-invoice-success-modal.component.scss'],
})
export class GenerateInvoiceSuccessModalComponent implements OnInit {
  boobleModalData: any;
  isMobile = false;

  get companyId() {
    return +this.accountService.getCompanyId();
  }

  get individualId() {
    return +this.accountService.getIndividualId();
  }

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly accountService: AuthenticationService,
    private modalService: BoobleModalService,
    private matIconRegistry: MatIconRegistry,
    private domSanitzer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon(
      'success',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/sucess.svg')
    );
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 820 ? true : false;
  }

  closeModal() {
    this.modalService.dismiss(null);
  }
}
